import { useNavigate, useLocation } from 'react-router-dom';
import {
    AppstoreOutlined,
    PictureOutlined,
    FileTextOutlined,
    TeamOutlined,
    GlobalOutlined,
    PhoneOutlined,
    LogoutOutlined,
} from '@ant-design/icons';
import { Menu } from 'antd';
import './sidebar.css'; // кастомные стили (по желанию)

const Sidebar = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const currentKey = location.pathname.split('/')[1] || '';

    const handleNavigate = (path) => {
        navigate(path);
    };

    const logout = () => {
        localStorage.removeItem('token');
        navigate('/login');
    };

    return (
        <div className="min-h-screen w-64 bg-[#1f1f1f] text-white shadow-lg flex flex-col justify-between">
            <Menu
                mode="inline"
                theme="dark"
                selectedKeys={[currentKey]}
                className="flex-1 border-r border-gray-800"
                onClick={({ key }) => handleNavigate('/' + key)}
                items={[
                    { key: '', icon: <AppstoreOutlined />, label: 'Dashboard' },
                    { key: 'langs', icon: <GlobalOutlined />, label: 'Languages' },
                    { key: 'slides', icon: <PictureOutlined />, label: 'Slides' },
                    { key: 'services', icon: <FileTextOutlined />, label: 'Services' },
                    { key: 'portfolio', icon: <FileTextOutlined />, label: 'Portfolio' },
                    { key: 'about', icon: <TeamOutlined />, label: 'About Us' },
                    { key: 'partners', icon: <TeamOutlined />, label: 'Partners' },
                    { key: 'contact', icon: <PhoneOutlined />, label: 'Contact' },
                ]}
            />

            <div className="p-4 border-t border-gray-800 hover:bg-red-600 hover:text-white cursor-pointer transition-all text-center" onClick={logout}>
                <LogoutOutlined className="mr-2" />
                Logout
            </div>
        </div>
    );
};

export default Sidebar;
